// client/src/context/CartContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState(() => {
        try {
            const storedCart = localStorage.getItem('cart');
             return storedCart ? JSON.parse(storedCart) : [];
        } catch (error) {
            console.error("Error loading cart from localStorage", error);
             return [];
        }
    });

    const [orderType, setOrderType] = useState('dinein'); // 'dinein' or 'takeaway'

    useEffect(() => {
        try {
        localStorage.setItem('cart', JSON.stringify(cart));
    }
     catch(error) {
        console.error("Error saving cart to localStorage", error);
     }
    }, [cart]);


    const addItem = (item) => {
         setCart(prevCart => {
            const existingItemIndex = prevCart.findIndex(cartItem => cartItem._id === item._id);
            if(existingItemIndex > -1) {
                const updatedCart = [...prevCart];
                updatedCart[existingItemIndex].quantity += 1;
                return updatedCart;
            }
            return [...prevCart, {...item, quantity: 1}]
         });

    };


    const removeItem = (itemToRemove) => {
         setCart(prevCart => {
             return prevCart.filter(item => item._id !== itemToRemove._id)
         });
    };

    const updateQuantity = (itemId, newQuantity) => {
         setCart(prevCart => {
            return prevCart.map(item => {
               if (item._id === itemId) {
                   return { ...item, quantity: newQuantity}
               }
               return item;
           });
         });
    };

    const clearCart = () => {
        setCart([]);
    };


    const getTotal = () => {
        const takeawayCharge = orderType === 'takeaway' ? 10 : 0; // 10 Rupees for takeaway
        return cart.reduce((total, item) => {
            const itemPrice = item.price;
            const itemTotal = itemPrice * item.quantity;
            return total + itemTotal;
        }, 0);
     };

    return (
        <CartContext.Provider
            value={{
                cart,
                addItem,
                removeItem,
                updateQuantity,
                clearCart,
                getTotal,
                orderType, // Add orderType to context
                setOrderType // Add setOrderType to context
            }}
        >
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => {
    return useContext(CartContext);
};